import { Invoice } from '../../shared/models/invoice.model';

export function invoicePaymentStatusHtml(invoice: Invoice, showPaymentMatchingSource = false): string {
  if (invoice.status === 'CONFIRMED') {
    if (!showPaymentMatchingSource) {
      return '<span class="icon icon-positive text-success-s2 fs-3" title="Confirmed"></span>';
    }
    if (invoice.paymentMatchingSource === 'MANUAL') {
      return '<span class="icon icon-positive fs-3" style="color: #0d6efd" title="Marked as paid manually"></span>';
    }
    if (invoice.paymentMatchingSource === 'AUTOMATIC') {
      return '<span class="icon icon-positive text-success-s2 fs-3" title="Auto Agent"></span>';
    }
    if (invoice.paymentMatchingSource === 'PAYPAL') {
      return '<span class="icon icon-positive text-success-s2 fs-3" title="Auto PayPal"></span>';
    }
    return '<span class="icon icon-positive text-success-s2 fs-3" title="Confirmed"></span>';
  }

  const statusMap = {
    WAITING: '<span class="icon icon-wait fs-3" title="Waiting"></span>',
    PROCESSING: '<span class="icon icon-wait fs-3 text-warning-w2" title="Processing"></span>',
    VOID: '<span class="icon icon-close text-error-r2 fs-4" title="Void"></span>',
    PARTIALLY_PAID: '<span class="icon icon-check text-warning-w2 fs-4" title="Partially paid"></span>',
  };
  return statusMap[invoice.status] ?? '';
}
